import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { reportActionCreators } from '~/redux/ducks/playersAndTeams/report';
import { commonMessages } from '~/utility/commonMessages';

import Label from '../../label';
import { InputSeparator, TimeSelectContainer } from '../dateRangeSelect/styles';

import SeasonFromSelect from './components/SeasonFromSelect';
import SeasonToSelect from './components/SeasonToSelect';

import { SeasonRangeContainer, SumResultsContainer } from './styles';

const SeasonRangeSelect = () => {
    const dispatch = useDispatch();
    const isAggregate = useSelector((state) => state.playersAndTeams.report.current.isAggregate);

    const setIsAggregate = (e) => {
        dispatch(reportActionCreators.setIsAggregate(e.target.checked));
        dispatch(reportActionCreators.runReport());
    };

    return (
        <SeasonRangeContainer>
            <TimeSelectContainer>
                <Label htmlFor="seasonFrom">
                    <FormattedMessage {...commonMessages.filters.seasons} />
                </Label>
                <SumResultsContainer>
                    <input
                        type="checkbox"
                        name="sumResults"
                        id="sumResults"
                        onChange={setIsAggregate}
                        checked={isAggregate}
                    />
                    <Label htmlFor="sumResults">
                        <FormattedMessage {...commonMessages.labels.sumResults} />
                    </Label>
                </SumResultsContainer>
            </TimeSelectContainer>
            <TimeSelectContainer>
                <SeasonFromSelect />
                <InputSeparator>-</InputSeparator>
                <SeasonToSelect />
            </TimeSelectContainer>
        </SeasonRangeContainer>
    );
};

export default React.memo(SeasonRangeSelect);
